import { Eye, HelpCircle, Plus, Trash, X } from "lucide-react";

const GuarantorDocuments = ({
  closeGuarantorDocuments,
  guarantor,
  documents,
  handleAddGuarantorDocument,
}) => {
  return (
    <div
      onClick={(e) => {
        closeGuarantorDocuments();
      }}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[980px] overflow-y-auto h-[600px] p-[20px] bg-white rounded-[10px] relative"
      >
        <div
          onClick={closeGuarantorDocuments}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>
        <div className="absolute bottom-[10px] w-full px-[20px] right-0 flex items-center gap-[10px] justify-end">
          <button
            onClick={closeGuarantorDocuments}
            className="bg-[#000000] h-[35px] px-[20px] rounded-[30px] text-[#ffffff] font-medium text-[15px] flex items-center justify-center gap-[5px]"
          >
            Close
          </button>
        </div>
        <p className="text-[#000000] font-normal text-[14px]">
          Edit Loan Application
        </p>
        <p className="text-[#000000] font-semibold text-[20px]">
          Guarantor Loan Documents Information
        </p>
        <div className="flex items-center justify-between">
          <p className="text-[#5C5C5C] text-[14px] font-normal">
            Upload relevant documents associated with the guarantor
          </p>
          <button
            onClick={handleAddGuarantorDocument}
            className="h-[35px] bg-[#000000] flex items-center justify-center gap-[5px] rounded-[30px] px-[15px] text-[15px] font-bold text-white"
          >
            <Plus size={16} color="#ffffff" />
            Add Document
          </button>
        </div>
        <div className="h-[40px] bg-[#F3F3F3] my-[10px] pl-[10px] flex items-center">
          <div className="w-[10%]">ID</div>
          <div className="w-[30%] text-[14px] text-[#222222] font-normal">
            NAME
          </div>
          <div className="w-[20%] text-[14px] text-[#222222] font-normal">
            UPDATED
          </div>
          <div className="w-[20%] text-[14px] text-[#222222] font-normal">
            STATUS
          </div>
          <div className="w-[20%] truncate text-[14px] text-[#222222] font-normal">
            VIEW/ DOWNLOAD/ EDIT
          </div>
        </div>
        {documents?.length > 0 ? (
          documents?.map((doc) => (
            <div className="h-[40px] bg-[#F3F3F3] my-[10px] pl-[10px] flex items-center">
              <div className="w-[10%] truncate">{doc?.id}</div>
              <div className="w-[30%] truncate text-[14px] text-[#222222] font-normal">
                {doc?.documentType}
              </div>
              <div className="w-[20%] text-[14px] truncate text-[#222222] font-normal">
                {doc?.uploadedAt}
              </div>
              <div className="w-[20%] text-[14px] text-[#222222] font-normal">
                Uploaded
              </div>
              <div className="w-[20%] flex gap-3 items-center truncate text-[14px] text-[#222222] font-normal">
                <Eye className="w-4 h-4 text-[#222222] cursor-pointer" />
                <Trash
                  // onClick={() => handleDeleteDocument(doc)}
                  fill="#222222"
                  className="w-4 h-4 text-[#222222] cursor-pointer"
                />
              </div>
            </div>
          ))
        ) : (
          <div className="h-[350px] flex flex-col items-center justify-center gap-[10px]">
            <HelpCircle />
            <p>No loan document information available</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default GuarantorDocuments;
